import { render, staticRenderFns } from "./CustomerAssetsMain.vue?vue&type=template&id=38d07bed"
import script from "./CustomerAssetsMain.vue?vue&type=script&lang=js"
export * from "./CustomerAssetsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports